export async function getRequireRoles(singularName: string) {
    const ctx = strapi.requestContext.get();
    const user = ctx?.state?.user;
    const roleIds = user.roles.map((role) => role.id);
    const permissionList = await strapi.entityService.findMany('admin::permission', {
      filters: {
        subject: singularName,
        role: {
          id: {
            $in: roleIds
          }
        }
      },
      populate: ['role'],
    });
    // @ts-ignore
    return permissionList && permissionList.reduce((currentValue, permission) => {
      const actionSplit = permission.action.split('.');
      if (actionSplit.length > 0) {
        currentValue.push(actionSplit[actionSplit.length - 1]);
      }
      return currentValue;
    }, []);
  }
